import React, { useState, useEffect, useRef, useCallback } from 'react';
import { images } from '../data';
import { useTranslation } from 'react-i18next';
import first from '../../../../assets/kido/first.jpeg'
import second from '../../../../assets/kido/second.jpeg'
import third from '../../../../assets/kido/third.jpeg'
import fourth from '../../../../assets/kido/fourth.jpeg'
import fifth from '../../../../assets/kido/fifth.jpeg'


// 👉 Replace with your own company images
const companyImages = [
  { src: first, alt: 'Our store' },
  { src: second, alt: 'Our team' },
  { src: third, alt: 'Our products' },
  { src: fourth, alt: 'Our services' },
  { src: fifth, alt: 'Our mission' },
];

export default function Hero({ copy }) {
  const { t } = useTranslation();
  const lines = t('kidoHero.welcome').split('\n');

  const total = companyImages.length;
  // clones of last + first slide make the loop seamless
  const slides = [companyImages[total - 1], ...companyImages, companyImages[0]];

  const [index, setIndex] = useState(1);
  const [animate, setAnimate] = useState(true);
  const [paused, setPaused] = useState(false);
  const locked = useRef(false);

  const goTo = useCallback((i) => {
    if (locked.current) return;
    locked.current = true;
    setAnimate(true);
    setIndex(i);
  }, []);

  const next = useCallback(() => goTo(index + 1), [goTo, index]);
  const prev = () => goTo(index - 1);

  // auto slide
  useEffect(() => {
    if (paused) return;
    const id = setInterval(next, 3500);
    return () => clearInterval(id);
  }, [next, paused]);

  // after reaching a clone, silently jump to the real slide
  const handleTransitionEnd = () => {
    locked.current = false;
    if (index === 0) {
      setAnimate(false);
      setIndex(total);
    } else if (index === total + 1) {
      setAnimate(false);
      setIndex(1);
    }
  };

  // re-enable animation after the silent jump
  useEffect(() => {
    if (!animate) {
      const id = requestAnimationFrame(() =>
        requestAnimationFrame(() => setAnimate(true))
      );
      return () => cancelAnimationFrame(id);
    }
  }, [animate]);

  const activeDot = (index - 1 + total) % total;

  return (
    <section className="kido-hero" id="top">
      <div className="kido-hero-copy">
        <p className="kido-eyebrow">{copy.label}</p>
        <h1>
          {lines.map((line, i) => (
            <span key={line}>{line}{i === 0 && <br />}</span>
          ))}
        </h1>
        <p className="kido-hero-sub">{t('kidoHero.subtitle')}</p>
        <a className="kido-yellow-button" href="#shop">{t('kidoHero.cta')}<span>↗</span></a>
      </div>

      <div
        className="kido-slider"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div className="kido-slider-viewport">
          <div
            className="kido-slider-track"
            style={{
              transform: `translateX(-${index * 100}%)`,
              transition: animate ? 'transform 0.6s ease' : 'none',
            }}
            onTransitionEnd={handleTransitionEnd}
          >
            {slides.map((img, i) => (
              <div className="kido-slide" key={i}>
                <img src={img.src} alt={img.alt} />
              </div>
            ))}
          </div>
        </div>

        <button className="kido-arrow kido-arrow-left" onClick={prev} aria-label="Previous slide">‹</button>
        <button className="kido-arrow kido-arrow-right" onClick={next} aria-label="Next slide">›</button>

        <div className="kido-dots">
          {companyImages.map((_, i) => (
            <button
              key={i}
              className={`kido-dot ${i === activeDot ? 'active' : ''}`}
              onClick={() => goTo(i + 1)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}